import { Col, FormGroup, Row, Text } from '@ksyos/design-system';
import { useState } from 'react';
import type { ITimeRange } from '@common/validation/callBackMoment';
import type { ITimeSlots } from '@common/validation/timeSlots';
import type { ValidationErrors } from '@frontend/utils/validation';
import { useViewportWidth } from '@frontend/utils/hooks';
import { translateKey } from '../../translate/index';
import { TimeRangeAddEdit } from './TimeRangeAddEdit';

interface ITimeRangesAddEditProps {
    error?: string;
    errors: ValidationErrors;
    onChange: (value: ITimeSlots, timeSlots: keyof ITimeSlots) => void;
    onDoValidate: () => void;
    timeSlots: ITimeSlots;
}

export function TimeRangesAddEdit(props: ITimeRangesAddEditProps) {
    const [timeRanges, setTimeRanges] = useState(props.timeSlots);

    const { width } = useViewportWidth();

    return (
        <FormGroup
            hasErrors={
                props.errors.has(`${props.error}.firstTimeRange.startTime`) ||
                props.errors.has(`${props.error}.firstTimeRange.endTime`) ||
                props.errors.has(`${props.error}.secondTimeRange.startTime`) ||
                props.errors.has(`${props.error}.secondTimeRange.endTime`)
            }
            label={translateKey('contactsAndTasks.availability')}
        >
            <Row columnGap={1}>
                <Col span={4}>
                    <TimeRangeAddEdit
                        endTime={props.timeSlots.firstTimeRange.endTime}
                        endTimePlaceholder="12:00"
                        error={`${props.error}.firstTimeRange`}
                        errors={props.errors}
                        onChange={(value, period) => handleChangeTimeRange(value, period, 'firstTimeRange')}
                        onDoValidate={() => props.onDoValidate()}
                        startTime={props.timeSlots.firstTimeRange.startTime}
                        startTimePlaceholder="09:00"
                    ></TimeRangeAddEdit>
                </Col>
                <Col
                    span={1}
                    style={width < 1250 ? { display: 'flex', alignItems: 'center', justifyContent: 'center' } : {}}
                >
                    <Text
                        as="small"
                        mt={3}
                        size="sm"
                        textAlign="center"
                    >
                        {translateKey('common.and')}
                    </Text>
                </Col>
                <Col span={4}>
                    <TimeRangeAddEdit
                        endTime={props.timeSlots.secondTimeRange.endTime}
                        endTimePlaceholder="17:00"
                        error={`${props.error}.secondTimeRange`}
                        errors={props.errors}
                        onChange={(value, period) => handleChangeTimeRange(value, period, 'secondTimeRange')}
                        onDoValidate={() => props.onDoValidate()}
                        startTime={props.timeSlots.secondTimeRange.startTime}
                        startTimePlaceholder="15:00"
                    ></TimeRangeAddEdit>
                </Col>
            </Row>
        </FormGroup>
    );

    function handleChangeTimeRange(value: string | null, period: keyof ITimeRange, range: keyof ITimeSlots) {
        const timeSlotsUpdate = {
            ...props.timeSlots,
            [range]: { ...timeRanges[range], [period]: value },
        };

        setTimeRanges(timeSlotsUpdate);
        props.onChange(timeSlotsUpdate, range);
    }
}
